import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styles from './RewardList.css';
import GainPointItemInfo from './GainPointItemInfo';

class GainPointList extends Component {
  render() {
    const { itemRules, removeGainPointItem } = this.props;
    const views = [];
    for (let i = 0; i < itemRules.length; i++) {
      const divClassName = 'row';
      const rule = itemRules[i];
      views.push(
        <div className={divClassName}>
          <GainPointItemInfo
            gainPointType={rule.type}
            point={rule.point}
            categoryName={rule.categoryName}
            itemName={rule.itemName}
            itemVariantNames={rule.itemVariantNames}
            index={i}
            removeGainPointItem={removeGainPointItem}
            isLastRow={i === itemRules.length - 1}
            isFirstRow={i === 0}
          />
        </div>
      );
    }

    return (
      <div className="bottom30">
        <div
          className="row"
          style={{
            backgroundColor: 'rgba(203, 203, 203, 0.48)',
            padding: '5px',
            margin: '0px',
            borderTopRightRadius: '4px',
            borderTopLeftRadius: '4px',
          }}
        >
          {views.length > 0 && itemRules[0].type !== 'CATEGORY' && (
            <div style={{ paddingLeft: '8px' }} className="col-md-4">
              <b>Item</b>
            </div>
          )}
          {views.length > 0 && itemRules[0].type !== 'CATEGORY' && (
            <div style={{ paddingLeft: '0px' }} className="col-md-8">
              <b>Variants</b>
            </div>
          )}
          {views.length > 0 && itemRules[0].type === 'CATEGORY' && (
            <div style={{ paddingLeft: '8px' }} className="col-md-12">
              <b>Category</b>
            </div>
          )}
        </div>
        {views.length === 0 && (
          <div className="col-md-8" style={{ color: 'red' }}>
            No data to display, please add minimum one reward.
          </div>
        )}
        <div className={`${removeGainPointItem ? '' : styles['list-box']}`}>
          {views}
        </div>
      </div>
    );
  }
}

GainPointList.propTypes = {
  itemRules: PropTypes.array.isRequired,
  removeGainPointItem: PropTypes.func,
};

export default GainPointList;
